import { useState } from 'react'

/**
 * Eine Zufallszahl `0 … count-1`, gewählt beim Einhängen und dann behalten.
 * So wechselt etwas (Titel, Motiv) beim nächsten Besuch, nicht bei jedem
 * Re-Render. Für die leeren Zustände auf Geschafft und Ruhend.
 */
export function useStableRandomIndex(count: number): number {
  const [index] = useState(() => Math.floor(Math.random() * count))
  return count > 0 ? index % count : 0
}
